// Centralized Spring Boot host mapping for region lookup and other SBAPI calls
// Extend or modify this mapping as environments are added.
export const SPRINGBOOT_HOST_MAPPING = {
    'iam-dev.pearson.com': 'https://springboot-dev.identity-nonprd.pearson.com',
    'iam-stage.pearson.com': 'https://springboot-stage.identity-nonprd.pearson.com',
    'iam-ppe.pearson.com': 'https://springboot-ppe.identity-nonprd.pearson.com',
    'iam.pearson.com': 'https://springboot-prod.identity-prd.pearson.com',
    'localhost': 'https://springboot-dev.identity-nonprd.pearson.com'
};

// Returns the mapped Spring Boot base URL for a given window/location hostname.
// Falls back to production host if hostname not explicitly mapped.
export function getSpringBootHost (hostname) {
    return SPRINGBOOT_HOST_MAPPING[hostname] || SPRINGBOOT_HOST_MAPPING['iam.pearson.com'];
}
